import { isPlatformBrowser } from '@angular/common';

const DEVICE_ID_STORAGE_KEY = 'fibo_device_id';

/**
 * Returns a stable browser device identifier persisted in localStorage.
 * Generates a UUID on first use and reuses it on subsequent visits.
 */
export function getOrCreateDeviceId(platformId: object): string {
  if (!isPlatformBrowser(platformId)) {
    return 'server';
  }

  try {
    const existing = localStorage.getItem(DEVICE_ID_STORAGE_KEY);
    if (existing) {
      return existing;
    }

    const deviceId = crypto.randomUUID();
    localStorage.setItem(DEVICE_ID_STORAGE_KEY, deviceId);
    return deviceId;
  } catch (error) {
    console.warn('[FCM] Unable to persist device id in localStorage; using session UUID.', error);
    return crypto.randomUUID();
  }
}
